import React from "react";
import { Layout } from "../layout/Layout.js";
import { FixedTable } from "../../../packages/ui/table/quick/FixedTable.js";
import { Column } from "../../../packages/ui/table/quick/Column.js";
import { getPathRecords } from "./analyticsApi.js";
import { PathRecord } from "../../model/analytics/PathRecord.js";
import { useRequiredParameter } from "../../../packages/router/params/useRequiredParameter.js";
import { useLoadEffect } from "../../../react/load/useLoadEffect.js";

/**
 * Shows analytics for the given file.
 */
export const AnalyticsFilePage = () => {
  const file = useRequiredParameter("file");
  const result = useLoadEffect(`analytics-file-${file}`, () => getPathRecords(file));

  const columns: Column<PathRecord>[] = [
    {
      span: 3,
      title: "Fail",
      render: (row: PathRecord) => row.path
    },
    {
      span: 4,
      title: "Pealkiri",
      render: (row: PathRecord) => row.title
    },
    {
      span: 1,
      title: "Lugejaid",
      render: (row: PathRecord) => row.count,
      textAlign: "right"
    }
  ];

  return (
    <Layout title="Analüütika" containerWidth="fixed-wide-min">
      <h2>Analüütika - {file}</h2>
      {result.state === "success" && <FixedTable columns={columns} rows={result.data} fontSize="tiny" />}
    </Layout>
  );
};
